module.exports = __webpack_public_path__ + "static/media/audit_log_avatar.be6d6863.png";